import { NavLink } from 'react-router-dom';
import { Flame, Home, MessagesSquare, Star, Sun } from 'lucide-react';
import { cn } from '@/lib/utils';

const ITEMS = [
  { to: '/', label: 'Today', icon: Sun, exact: true },
  { to: '/overview', label: 'Overview', icon: Home },
  { to: '/reviews', label: 'Reviews', icon: MessagesSquare },
  { to: '/ratings', label: 'Ratings', icon: Star },
  { to: '/alerts', label: 'Alerts', icon: Flame },
];

export function MobileBottomNav() {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-30 border-t border-border/60 bg-background/90 backdrop-blur md:hidden"
      aria-label="Primary"
    >
      <ul className="grid grid-cols-5">
        {ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.exact}
                className={({ isActive }) =>
                  cn(
                    'flex flex-col items-center gap-0.5 py-2.5 text-2xs',
                    isActive ? 'text-foreground' : 'text-muted-foreground',
                  )
                }
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
